// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const ReportLayoutSortModel = t.struct({
    colId: t.String,
    sort: t.String
}, {
    name: 'ReportLayoutSortModel'
});

export const getDefaultState = () => new ReportLayoutSortModel({
    colId: '',
    sort: ''
});

export default ReportLayoutSortModel;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/report-layout-sort-model.js